(function () {
  const icons = [
    '୨୧',
    '✦☆･✧',
    '✧',
    '☾',
    '☽',
    '⋆',
    '₊･*｡',
    '˚',
    '♡'
  ];

  const isFinePointer = window.matchMedia("(pointer: fine)").matches;

  function makeSparkle(x, y, strong) {
    const s = document.createElement("span");
    s.className = "euphoria-sparkle";
    s.textContent = icons[Math.floor(Math.random() * icons.length)];

    const size = strong ? 13 + Math.random() * 8 : 5 + Math.random() * 5;

    // 最初は後ろに細く流す
    const dx = -18 - Math.random() * 18;
    const dy = -4 - Math.random() * 8;

    // 最後だけふわっと末広がり
    const spread = strong ? 16 + Math.random() * 22 : 8 + Math.random() * 18;
    const spreadX = (Math.random() - 0.5) * spread;
    const spreadY = (Math.random() - 0.5) * spread;

    s.style.left = x + "px";
    s.style.top = y + "px";
    s.style.fontSize = size + "px";
    s.style.setProperty("--dx", dx + "px");
    s.style.setProperty("--dy", dy + "px");
    s.style.setProperty("--spreadX", spreadX + "px");
    s.style.setProperty("--spreadY", spreadY + "px");

    document.body.appendChild(s);
    setTimeout(() => s.remove(), 1500);
  }

  const style = document.createElement("style");
  style.textContent = `
    .euphoria-sparkle {
      position: fixed;
      pointer-events: none;
      z-index: 2147483646;
      color: rgba(248, 240, 186, 0.88);
      text-shadow:
        0 0 6px rgba(251, 244, 182, 0.9),
        0 0 14px rgba(249, 228, 188, 0.82);
      transform: translate(-50%, -50%);
      animation: euphoriaSparkle 1.25s ease-out forwards;
      will-change: transform, opacity;
    }

    @keyframes euphoriaSparkle {
      0% {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1) rotate(0deg);
      }

      65% {
        opacity: .85;
        transform:
          translate(calc(-50% + var(--dx)), calc(-50% + var(--dy)))
          scale(.85)
          rotate(2deg);
      }

      100% {
        opacity: 0;
        transform:
          translate(
            calc(-50% + var(--dx) + var(--spreadX)),
            calc(-50% + var(--dy) + var(--spreadY))
          )
          scale(.55)
          rotate(8deg);
      }
    }
  `;
  document.head.appendChild(style);

  let last = 0;

  document.addEventListener("mousemove", function (e) {
    if (!isFinePointer) return;

    const now = Date.now();
    if (now - last < 12) return;
    last = now;

    // Emit directly from the true pointer rather than the delayed key.
    const tailX = e.clientX;
    const tailY = e.clientY;

    const prev = window.lastSparklePos || {
      x: tailX,
      y: tailY
    };

    const moveX = tailX - prev.x;
    const moveY = tailY - prev.y;
    const distance = Math.hypot(moveX, moveY);

    // 数字が小さいほど線が濃い。重かったら 4〜5 にする
    const steps = Math.max(1, Math.floor(distance / 3));

    for (let i = 0; i <= steps; i++) {
      const t = i / steps;

      makeSparkle(
        prev.x + moveX * t + (Math.random() - 0.5) * 2,
        prev.y + moveY * t + (Math.random() - 0.5) * 2,
        false
      );
    }

    window.lastSparklePos = {
      x: tailX,
      y: tailY
    };
  }, { passive: true });

  document.addEventListener("click", function (e) {
    const tailX = e.clientX;
    const tailY = e.clientY;

    for (let i = 0; i < 12; i++) {
      makeSparkle(
        tailX + (Math.random() - 0.5) * 16,
        tailY + (Math.random() - 0.5) * 16,
        true
      );
    }
  });

  document.addEventListener("touchmove", function (e) {
    const touch = e.touches[0];
    if (!touch) return;

    const now = Date.now();
    if (now - last < 16) return;
    last = now;

    const prev = window.lastTouchSparklePos || {
      x: touch.clientX,
      y: touch.clientY
    };

    const moveX = touch.clientX - prev.x;
    const moveY = touch.clientY - prev.y;
    const distance = Math.hypot(moveX, moveY);
    const steps = Math.max(1, Math.floor(distance / 4));

    for (let i = 0; i <= steps; i++) {
      const t = i / steps;

      makeSparkle(
        prev.x + moveX * t + (Math.random() - 0.5) * 2,
        prev.y + moveY * t + (Math.random() - 0.5) * 2,
        true
      );
    }

    window.lastTouchSparklePos = {
      x: touch.clientX,
      y: touch.clientY
    };
  }, { passive: true });
})();
